export default {

    giftData:{
        type:Array,
        default:function () {
            return [];
        }
    }

}
